/* Cross-sell "Sumá a tu compra" — iMarket. Quick-add sin salir de la pagina ni del carrito.
   Portado de GangaShop: metricas cacheadas + arranque diferido (no traba Safari iOS). */
(function(){
  if (window.__xsellImLoaded) return; window.__xsellImLoaded = true;

  var BAG = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 8h12l-1 12H7L6 8Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9 9V7a3 3 0 0 1 6 0v2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';

  function money(cents){ try { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$'+(cents/100).toLocaleString('es-UY'); } catch(e){ return '$'+(cents/100); } }
  function openDrawer(){ document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}})); }
  function addToCart(vid, onOk, onErr){
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){ openDrawer(); if(onOk) onOk(); })
      .catch(function(){ if(onErr) onErr(); });
  }

  function buildQuickAdd(p, addBtn){
    var variants = p.variants || [];
    var opts = p.options || [];
    if (variants.length <= 1 || !opts.length) return null;
    if (opts.length === 1 && (opts[0].name === 'Title' || (opts[0].values||[]).join('') === 'Default Title')) return null;
    var qa = document.createElement('div'); qa.className='xsell__qa'; qa.hidden = true;
    var close = document.createElement('button'); close.type='button'; close.className='xsell__qa-close'; close.innerHTML='&times;'; close.setAttribute('aria-label','Cerrar');
    close.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); qa.hidden = true; });
    qa.appendChild(close);
    var ttl = document.createElement('div'); ttl.className='xsell__qa-title'; ttl.textContent = 'Elegí y agregá'; qa.appendChild(ttl);
    var optsWrap = document.createElement('div'); optsWrap.className='xsell__qa-opts'; qa.appendChild(optsWrap);
    var addBtnQ = document.createElement('button'); addBtnQ.type='button'; addBtnQ.className='xsell__qa-add'; addBtnQ.textContent='Elegí opción'; addBtnQ.disabled=true; qa.appendChild(addBtnQ);

    var sel = new Array(opts.length).fill(null);
    function resolve(){
      if (sel.some(function(x){ return x==null; })) return null;
      for (var i=0;i<variants.length;i++){
        var vo = variants[i].options || [];
        var ok = true;
        for (var j=0;j<sel.length;j++){ if (vo[j] !== sel[j]) { ok=false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    function valueAvailable(oi, val){ return variants.some(function(v){ return (v.options||[])[oi] === val && v.available; }); }
    function sync(){
      var v = resolve();
      if (v && v.available){ addBtnQ.disabled=false; addBtnQ.textContent='Agregar · '+money(v.price); }
      else if (v && !v.available){ addBtnQ.disabled=true; addBtnQ.textContent='Sin stock'; }
      else { addBtnQ.disabled=true; addBtnQ.textContent='Elegí opción'; }
    }
    opts.forEach(function(opt, oi){
      var row = document.createElement('div');
      var lab = document.createElement('span'); lab.className='xsell__qa-optlabel'; lab.textContent = opt.name; row.appendChild(lab);
      var chips = document.createElement('div'); chips.className='xsell__chips';
      (opt.values||[]).forEach(function(val){
        var c = document.createElement('button'); c.type='button'; c.className='xsell__chip'; c.textContent=val;
        if (!valueAvailable(oi, val)) c.disabled = true;
        c.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation();
          sel[oi]=val;
          Array.prototype.forEach.call(chips.children, function(x){ x.classList.toggle('is-sel', x===c); });
          sync();
        });
        chips.appendChild(c);
      });
      row.appendChild(chips); optsWrap.appendChild(row);
    });
    addBtnQ.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation();
      var v = resolve(); if (!v || !v.available) return;
      addBtnQ.disabled=true; addBtnQ.textContent='Agregando...';
      addToCart(v.id, function(){ qa.hidden=true; addBtn.classList.add('is-added'); addBtn.innerHTML='✓'; setTimeout(function(){ addBtn.classList.remove('is-added'); addBtn.innerHTML=BAG; },1500); sel.fill(null); Array.prototype.forEach.call(optsWrap.querySelectorAll('.xsell__chip'),function(x){x.classList.remove('is-sel');}); sync(); },
        function(){ addBtnQ.disabled=false; addBtnQ.textContent='Reintentá'; });
    });
    return qa;
  }

  function card(p){
    var variants = p.variants || [];
    var v0 = variants[0] || {};
    var multi = variants.length > 1;
    var el = document.createElement('div'); el.className='xsell__card';
    var media = document.createElement('a'); media.className='xsell__media'; media.href=p.url;
    var img = document.createElement('img'); img.src=(p.featured_image||'')+'&width=180'; img.alt=p.title||''; img.loading='lazy'; media.appendChild(img);
    var info = document.createElement('a'); info.className='xsell__info'; info.href=p.url;
    var nm = document.createElement('span'); nm.className='xsell__name'; nm.textContent=p.title||''; info.appendChild(nm);
    var pr = document.createElement('span'); pr.className='xsell__price';
    var priceHtml = '<strong>'+money(p.price)+'</strong>';
    if (p.compare_at_price && p.compare_at_price > p.price) priceHtml += ' <s>'+money(p.compare_at_price)+'</s>';
    pr.innerHTML = priceHtml; info.appendChild(pr);
    var add = document.createElement('button'); add.type='button'; add.className='xsell__add'; add.innerHTML=BAG;
    add.setAttribute('aria-label', multi ? 'Elegí opciones' : 'Agregar al carrito');
    var qa = buildQuickAdd(p, add);
    el.appendChild(media); el.appendChild(info); el.appendChild(add); if (qa) el.appendChild(qa);
    add.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      if (!qa){
        if (!v0.id || v0.available === false){ return; }
        add.disabled = true;
        addToCart(v0.id, function(){ add.classList.add('is-added'); add.innerHTML='✓'; setTimeout(function(){ add.classList.remove('is-added'); add.innerHTML=BAG; add.disabled=false; },1500); },
          function(){ add.disabled=false; });
        return;
      }
      qa.hidden = false;
    });
    return el;
  }

  function initOne(root){
    if (!root || root.dataset.xsellInit) return; root.dataset.xsellInit = '1';
    var pid = root.getAttribute('data-product-id');
    if (!pid) { root.remove(); return; }
    var track = root.querySelector('[data-xsell-track]');
    var countEl = root.querySelector('[data-xsell-count]');
    var prevBtn = root.querySelector('[data-xsell-prev]');
    var nextBtn = root.querySelector('[data-xsell-next]');

    /* Métricas CACHEADAS: nunca se leen medidas dentro del handler de scroll
       (leer layout en scroll fuerza reflow sincrónico y traba/mata la pestaña en Safari iOS). */
    var M = { step:260, clientW:0, scrollW:0, pages:1, pageAmt:260 };
    function measure(n){
      var c = track.querySelector('.xsell__card');
      var w = c ? c.getBoundingClientRect().width : 0;
      M.step = (w > 20 ? w : 248) + 12;
      M.clientW = track.clientWidth;
      M.scrollW = track.scrollWidth;
      var pv = (M.clientW > 10) ? Math.max(1, Math.round(M.clientW / M.step)) : 1;
      M.perView = pv;
      M.pages = Math.max(1, Math.ceil((n || 1) / pv));
      M.pageAmt = (M.clientW > 10) ? M.clientW : M.step;
    }
    var ticking=false;
    /* Solo lee scrollLeft (barato); el resto sale de la caché. */
    function updateCount(){
      var sl = track.scrollLeft;
      var cur = Math.min(M.pages, Math.round(sl / (M.step * (M.perView||1))) + 1);
      countEl.textContent = cur + '/' + M.pages;
      prevBtn.disabled = sl <= 4;
      nextBtn.disabled = sl + M.clientW >= M.scrollW - 4;
    }

    fetch('/recommendations/products.json?product_id='+pid+'&intent=related&limit=6')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var products = (d && d.products) || [];
        var exclRaw = (root.getAttribute('data-exclude')||'').split(',').filter(Boolean);
        var excl = {}; exclRaw.forEach(function(id){ excl[String(id)] = 1; });
        products = products.filter(function(p){ return !excl[String(p.id)]; });
        if (!products.length){ root.remove(); return; }
        products.forEach(function(p){ track.appendChild(card(p)); });
        root.hidden = false;
        var n = products.length;
        measure(n); updateCount();
        /* passive: le avisa a Safari que no vamos a bloquear el scroll */
        track.addEventListener('scroll', function(){
          if(ticking) return; ticking=true;
          window.requestAnimationFrame(function(){ updateCount(); ticking=false; });
        }, {passive:true});
        prevBtn.addEventListener('click', function(){ track.scrollBy({left:-M.pageAmt, behavior:'smooth'}); });
        nextBtn.addEventListener('click', function(){ track.scrollBy({left:M.pageAmt, behavior:'smooth'}); });
        /* re-medir solo cuando cambia el layout, nunca durante el scroll */
        var rt;
        window.addEventListener('resize', function(){
          clearTimeout(rt);
          rt = setTimeout(function(){ measure(n); updateCount(); }, 150);
        }, {passive:true});
        if (window.ResizeObserver) { try { new ResizeObserver(function(){ measure(n); updateCount(); }).observe(track); } catch(e){} }
      })
      .catch(function(){ root.remove(); });
  }

  /* Arranque diferido: el carrusel (fetch + 10 tarjetas) no compite con la carga de la página.
     El arranque es el peor momento (swiper, decodificación de fotos, apps); esto lo corre después.
     Nota: el bloque nace con [hidden] (sin caja), por eso no sirve IntersectionObserver acá. */
  function defer(root){
    if (!root || root.dataset.xsellQueued) return; root.dataset.xsellQueued = '1';
    var done = false;
    function go(){ if (done) return; done = true; initOne(root); }
    if (document.readyState === 'complete') { setTimeout(go, 200); }
    else { window.addEventListener('load', function(){ setTimeout(go, 400); }, {once:true}); setTimeout(go, 4000); }
    /* si el cliente interactúa antes, lo construimos ya */
    ['touchstart','pointerdown','keydown'].forEach(function(ev){
      window.addEventListener(ev, go, {once:true, passive:true});
    });
  }

  function scan(){ document.querySelectorAll('[data-xsell]:not([data-xsell-init])').forEach(defer); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  // Re-escanear cuando el carrito se re-renderiza (drawer inyectado por AJAX)
  document.addEventListener('cart:refresh', function(){ setTimeout(scan, 60); });
  document.addEventListener('cart:updated', function(){ setTimeout(scan, 60); });
  document.addEventListener('cart:build', function(){ setTimeout(scan, 60); });
  ['cart:change','cart:added','cart:open','side-cart:open','ajaxCart.afterCartLoad'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(scan, 60); });
  });

  /* Respaldo: el drawer se inyecta por AJAX (?section_id=side-cart) y en este tema
     es un <aside> con clase ofuscada (m6pn), asi que no sirve buscarlo por nombre.
     Se observa el body, pero el callback sale enseguida si no hay nada pendiente:
     ese querySelector es barato y corre como maximo una vez por cuadro. */
  function observeDrawer(){
    if (document.body.__xsellObs) return; document.body.__xsellObs = true;
    var pending = false;
    new MutationObserver(function(){
      if (pending) return;
      if (!document.querySelector('[data-xsell]:not([data-xsell-init])')) return;  // guard barato
      pending = true;
      window.requestAnimationFrame(function(){ pending = false; scan(); });
    }).observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeDrawer);
  else observeDrawer();

  /* El drawer se pide por fetch: en cuanto llega esa respuesta, el markup ya esta
     por montarse. Es la senal mas directa y no depende de los eventos del tema. */
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function(){
      var url = arguments[0];
      var esCarrito = typeof url === 'string' && (url.indexOf('section_id=side-cart') > -1 || url.indexOf('/cart') > -1);
      var p = _fetch.apply(this, arguments);
      if (esCarrito) p.then(function(r){ setTimeout(scan, 120); return r; }).catch(function(){});
      return p;
    };
  }
})();
